<template>
	<div class="business">
		<p>
			<i class="el-icon-s-home"></i>
			<span @click="$router.replace('/')">网站首页</span>/ 政策法规/ 会员企业名录
		</p>
		<h2 style="text-align:center;margin:20px 0">会员企业名录</h2>
	</div>
</template>

<script>
	export default {
		data() {
			return {};
		},
		mounted() {},
		methods: {},
	};
</script>
<style scoped>
	.business > p {
		width: 100%;
		border-bottom: 1px solid #ddd;
		padding-bottom: 10px;
		color: gray;
	}

	.business > p i {
		margin-right: 10px;
	}

	.business > p span:hover {
		color: #016fb8;
		cursor: pointer;
	}
</style>
